import { arrayOf, number, string } from "prop-types";
import React from "react";

import styles from "./StageTooltipContent.module.scss";

const StageTooltipContent = ({
  stageName,
  opportunityCount,
  opportunityNames,
  remainingCount,
  color,
}) => (
  <div>
    <p className={styles.stageTooltipContent__header}>
      {stageName} · {opportunityCount} opportunities
    </p>
    <ul className={styles.stageTooltipContent__list}>
      {opportunityNames.map((name, i) => (
        <li
          key={`${name}-${i}`}
          className={styles.stageTooltipContent__item}
        >
          <span
            aria-hidden="true"
            className={styles.stageTooltipContent__bullet}
            style={{ backgroundColor: color }}
          />
          <span>{name}</span>
        </li>
      ))}
    </ul>
    {remainingCount > 0 && (
      <p className={styles.stageTooltipContent__more}>
        …and {remainingCount} more
      </p>
    )}
  </div>
);

StageTooltipContent.propTypes = {
  stageName: string.isRequired,
  opportunityCount: number.isRequired,
  opportunityNames: arrayOf(string).isRequired,
  remainingCount: number.isRequired,
  color: string.isRequired,
};

export default StageTooltipContent;
